import { normalizeComplianceStandardCode } from './complianceStandard';
import { normalizeStarterRelevantStandards } from './standardCanonicalUx';

/** Legacy starter-guide checkbox values (stored in userQuestionnaire.relevantStandards). */
export const STARTER_STANDARD_OPTIONS = [
  'GDPR',
  'DORA',
  'NIS2',
  'SOC 2',
  'ISO/IEC 27001',
  'ISO/IEC 42001:2023',
  'PCI DSS 2025',
  'SWIFT CSCF 2025',
  'SDLC Security',
  'Technical Controls',
  'ENS_ES',
  'BSI_DE',
  'ANSSI_FR',
  'KSBP_LT',
  'NCA_EE',
  'CIS Controls v8',
] as const;

const CANONICAL_TO_STARTER_LABEL: Record<string, string> = {
  GDPR: 'GDPR',
  DORA: 'DORA',
  NIS2: 'NIS2',
  SOC2: 'SOC 2',
  ISO27001: 'ISO/IEC 27001',
  ISO42001: 'ISO/IEC 42001:2023',
  PCI_DSS_2025: 'PCI DSS 2025',
  SWIFT_CSCF_2025: 'SWIFT CSCF 2025',
  SDLC_SECURITY: 'SDLC Security',
  TECH_CONTROLS: 'Technical Controls',
  TECHNICAL_CONTROLS: 'Technical Controls',
  ENS_ES: 'ENS_ES',
  BSI_DE: 'BSI_DE',
  ENS_ANSSI: 'ANSSI_FR',
  ANSSI_FR: 'ANSSI_FR',
  KSBP_LT: 'KSBP_LT',
  NCA_EE: 'NCA_EE',
  CIS: 'CIS Controls v8',
};

function starterLabelForCanonical(code: string): string | null {
  const canon = normalizeComplianceStandardCode(code);
  if (CANONICAL_TO_STARTER_LABEL[canon]) return CANONICAL_TO_STARTER_LABEL[canon];
  return canon || null;
}

/**
 * Options shown in Starter Guide. When org/user grants exist, list is limited to granted
 * standards (plus legacy labels) so admin assignments match what users can select.
 */
export function resolveStarterGuideDisplayStandards(
  grantedCanonicalCodes: string[] | null | undefined,
): string[] {
  const legacy = [...STARTER_STANDARD_OPTIONS];
  const granted = (grantedCanonicalCodes || [])
    .map((c) => String(c || '').trim())
    .filter(Boolean);
  if (granted.length === 0) return legacy;

  const grantedCanon = new Set(
    granted.map((c) => normalizeComplianceStandardCode(c)).filter((c) => c && c !== 'ALL'),
  );
  const fromLegacy = legacy.filter((label) =>
    grantedCanon.has(normalizeComplianceStandardCode(label)),
  );
  const labels = new Set(fromLegacy);
  for (const code of granted) {
    const label = starterLabelForCanonical(code);
    if (label) labels.add(label);
  }
  const ordered = legacy.filter((l) => labels.has(l));
  for (const label of labels) {
    if (!ordered.includes(label)) ordered.push(label);
  }
  return ordered.length > 0 ? ordered : legacy;
}
